// Light, dark or follow the phone, chosen per device. public/theme-init.js applies the saved
// choice before first paint; this file changes it from Settings. Keep the two in step.

export type ThemeChoice = "system" | "light" | "dark";

const PREF_KEY = "pointz.theme";

// The --bg of each mode in styles.css, for the browser chrome (theme-color) around the page.
const BG = { light: "#ffffff", dark: "#0e0e10" };

/** This device's choice. Default: follow the phone. */
export function getTheme(): ThemeChoice {
  try {
    const saved = localStorage.getItem(PREF_KEY);
    return saved === "light" || saved === "dark" ? saved : "system";
  } catch {
    return "system";
  }
}

export function setTheme(choice: ThemeChoice): void {
  try {
    if (choice === "system") localStorage.removeItem(PREF_KEY);
    else localStorage.setItem(PREF_KEY, choice);
  } catch {
    /* storage blocked: the choice lasts until the page closes, which is the best on offer */
  }
  applyTheme(choice);
}

function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);

  // index.html has one theme-color per OS scheme. A forced choice paints both in its own colour;
  // System gives each back its own, so the browser follows the phone again by itself.
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    const own = meta.media.includes("dark") ? "dark" : "light";
    meta.content = BG[choice === "system" ? own : choice];
  }
}
